"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Predicates = void 0;
var Record_1 = require("fp-ts/Record");
/**
 *  @since 0.0.1
 */
var Predicates = function (tag) { return function (keys) { return ({
    is: Record_1.mapWithIndex(function (key, _) { return function (rest) { return rest[tag] === key; }; })(keys),
    verified: function (a) { return a[tag] in keys; },
    isAnyOf: function (keys) { return function (rest) {
        return keys.indexOf(rest[tag]) !== -1;
    }; }
}); }; };
exports.Predicates = Predicates;
